import { render } from "./BuybackHome.vue?vue&type=template&id=81c8db3e&scoped=true&ts=true&lang=pug"
import script from "./BuybackHome.vue?vue&type=script&lang=ts"
export * from "./BuybackHome.vue?vue&type=script&lang=ts"

import "./BuybackHome.vue?vue&type=style&index=0&id=81c8db3e&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81c8db3e"]])

export default __exports__